import React, { useEffect, useId } from 'react';

interface Props {
  open: boolean;
  title: string;
  children: React.ReactNode;
  /** Botões, abaixo do conteúdo. */
  actions: React.ReactNode;
  /** Fechar por Esc. Omita para diálogos que exigem uma escolha explícita. */
  onClose?: () => void;
  /**
   * `center`: mensagem curta de resultado (sucesso). `start`: confirmação/decisão — texto à
   * esquerda e ações alinhadas à direita.
   */
  align?: 'center' | 'start';
}

/** Diálogo modal com tokens de tema. `role=dialog` + `aria-modal`, título associado. */
const Dialog: React.FC<Props> = ({ open, title, children, actions, onClose, align = 'center' }) => {
  const titleId = useId();

  useEffect(() => {
    if (!open || !onClose) return undefined;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  const centered = align === 'center';
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        className={`w-full ${centered ? 'max-w-sm' : 'max-w-md'} rounded-panel border border-line bg-surface p-6 shadow-2xl ${centered ? 'text-center' : 'text-left'}`}
      >
        <h3 id={titleId} className="mb-2 text-lg font-bold text-fg">{title}</h3>
        <div className="space-y-1 text-sm text-fg-muted">{children}</div>
        <div className={`mt-5 ${centered ? '' : 'flex justify-end gap-2'}`}>{actions}</div>
      </div>
    </div>
  );
};

export default Dialog;
